import React from 'react';
import { Tooltip, TooltipProps } from 'antd';
import { createGlobalStyle, useTheme } from 'styled-components';
import { getTextStyle } from 'utils/getTextStyle';

export type AppTooltipProps = {
    children: React.ReactNode;
    tooltip: React.ReactNode;
    overlayStyle?: TooltipProps['overlayStyle'];
    overlayInnerStyle?: TooltipProps['overlayInnerStyle'];
    placement?: TooltipProps['placement'];
};

const GlobalStyle = createGlobalStyle`
  .ant-tooltip .ant-tooltip-content .ant-tooltip-inner {
        text-align: center;
        ${getTextStyle('BodyMedium')}
  }
`;

export const AppTooltip = ({
    children,
    tooltip,
    overlayStyle,
    overlayInnerStyle,
    placement,
}: AppTooltipProps) => {
    const theme = useTheme();
    return (
        <Tooltip
            title={tooltip}
            color={theme.colors.tooltip.tooltip2}
            overlayStyle={overlayStyle}
            overlayInnerStyle={overlayInnerStyle}
            placement={placement}
        >
            <GlobalStyle />
            {children}
        </Tooltip>
    );
};
